import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

import styles from "../../../../assets/styles/componentStyles/billingStyles/billingUsage.module.scss";

import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import IconsColor from "../../../utility/iconsColor";
import { billingSubscriptionFeatures } from "../../../../models/axiosModel";
import FeatureFreezeWarning from "./featureFreezeWarning";

type channelVariant = "whatsapp" | "instagram" | "facebook" | "website" | "slack";

const CHANNEL_PRESENTATION: Record<string, { label: string; icon: ReactNode; variant: channelVariant }> = {
    waba: {
        label: "WhatsApp",
        icon: <IconsColor iconName="whatsapp" width="18" height="18" fillColor="#fff" />,
        variant: "whatsapp",
    },
    instagram_professional_accounts: {
        label: "Instagram",
        icon: <IconsColor iconName="instagram" width="18" height="18" fillColor="#fff" />,
        variant: "instagram",
    },
    facebook_messenger: {
        label: "Facebook Messenger",
        icon: <IconsColor iconName="facebook" width="18" height="18" fillColor="#fff" />,
        variant: "facebook",
    },
    websites: {
        label: "Websites",
        icon: <IconsColor iconName="website" width="18" height="18" fillColor="#fff" />,
        variant: "website",
    },
    slack_workspaces: {
        label: "Slack",
        icon: <IconsColor iconName="slack" width="18" height="18" fillColor="#fff" />,
        variant: "slack",
    },
};

const ConnectedChannelItem = ({ feature }: { feature: billingSubscriptionFeatures }) => {
    
    const presentation = CHANNEL_PRESENTATION[feature.billing_feature_name] || {
        label: feature.billing_feature_display_name,
        icon: <LanguageOutlinedIcon />,
        variant: "website" as channelVariant,
    };

    const connectedCount = Number(feature.feature_used_amount) || 0;
    const channelLimit = Number(feature.feature_limit_value) || 0;
    const isInfinite = feature.flag_infinite;
    const isFreezed = feature.flag_freeze;

    return (
        <Box className={`${styles.connectedChannelItem} ${styles[presentation.variant]}`}>
            <Box className={styles.connectedChannelIcon}>
                {presentation.icon}
            </Box>

            <Box className={styles.connectedChannelText}>
                <Box className={styles.connectedChannelNameRow}>
                    <Typography className={styles.connectedChannelName}>
                        {presentation.label}
                    </Typography>

                    {isFreezed && (
                        <FeatureFreezeWarning placement="top" size="small" />
                    )}
                </Box>

                <Typography className={styles.connectedChannelStatus}>
                    {isInfinite
                        ? `${connectedCount} Connected`
                        : `${connectedCount}/${channelLimit} Connected`
                    }
                </Typography>
            </Box>
        </Box>
    );
};

export default ConnectedChannelItem;
